import { ConfigStore } from "../../store/modules/config";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "../operations/OperationVue";
import IOperationService from "../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { ChangePasswordModel } from "../../models/settings/changePasswordModel";

export class ChangePasswordVue extends OperationVue {
  /** Стор профиля */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get passwordLoading(): boolean {
    return this.configStore.loading;
  }

  get passwordRequirements() {
    return this.configStore.passwordRequirements;
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.service = container.get<IOperationService>(
      DiTokens.ChangePasswordService
    );
    this.OperationModel = (await this.service.init(
      this.passwordRequirements
    )) as ChangePasswordModel;
    this.loading = false;
  }
}
